import legalMessages from './legalDocsMessages';
import { getStaticMediaURL } from '../app/bootstrap';


export const getBalanceOrCustomerSupportUrl = (viewBalanceUrl, customerSupportUrl) => (
    viewBalanceUrl || customerSupportUrl
);

export const getViewBalanceUrlOrPhone = (intl, viewBalancePhone, viewBalanceUrl, customerSupportUrl) => {
    const viewBalanceOrCustomerSupportUrl = getBalanceOrCustomerSupportUrl(viewBalanceUrl, customerSupportUrl);
    const viewBalanceUrlMessage = intl.formatMessage(
        legalMessages.viewBalanceUrl, { url: viewBalanceOrCustomerSupportUrl }
    );

    
    if (!viewBalancePhone) {
        return viewBalanceUrlMessage;
    }

    
    const viewBalancePhoneMessage = intl.formatMessage(
        legalMessages.viewBalancePhone, { phone: viewBalancePhone }
    );

    return intl.formatMessage(legalMessages.viewBalanceUrlOrPhone, {
        url: viewBalanceUrlMessage,
        phone: viewBalancePhoneMessage
    });
};

export const getUyoTermsAndConditions = (intl, pageContext, digitalSupported, physicalSupported) => {
    
    const uyoTermsMessage = ((physicalSupported && digitalSupported) || physicalSupported)
        ? legalMessages.uyoTermsAndConditionsEGiftAndPhysical : legalMessages.uyoTermsAndConditionsEGift;
    const staticMediaUrl = getStaticMediaURL();

    return intl.formatMessage(uyoTermsMessage, {
        ...pageContext,
        uyoReplacementImageExample: `<div class="about-image">`
            + `<img src="${staticMediaUrl}/images/_common/replacement-uyo-image.jpg" `
            + `align="left" width="220" height="146" alt="Replacement Image"/></div>`
    });
};

export const getTermsAndConditions = (intl, pageContext, supportOptions) => {
    const { supportsDigital, supportsPhysical, isUyoSupported } = supportOptions;
    const uyoTermsAndConditions = isUyoSupported
        ? getUyoTermsAndConditions(intl, pageContext, supportsDigital, supportsPhysical) : '';
    const acceptedLocations = intl.formatMessage(legalMessages.acceptedLocations);

    const termsContext = {
        ...pageContext,
        uyoTermsAndConditions,
        acceptedLocations
    };

    
    const termsMessage = ((supportsPhysical && supportsDigital) || supportsPhysical)
        ? legalMessages.termsAndConditionsEGiftAndPhysical : legalMessages.termsAndConditionsEGift;

    return intl.formatMessage(
        termsMessage,
        termsContext
    );
};

export const getFAQ = (intl, pageContext, supportOptions) => {
    const {
        supportsDigital, supportsPhysical, isAccessoriesSupported, isPaypalSupported
    } = supportOptions;
    const { giftCardLabel } = pageContext;

    const costExplanation = isAccessoriesSupported
        ? intl.formatMessage(legalMessages.costExplanation, giftCardLabel) : '';
    const payPalFaq = isPaypalSupported ? intl.formatMessage(legalMessages.payPalFaq) : '';

    const acceptedLocations = intl.formatMessage(legalMessages.acceptedLocations);

    
    const faqMessage = ((supportsPhysical && supportsDigital) || supportsPhysical)
        ? legalMessages.faqEGiftAndPhysical : legalMessages.faqEGift;

    return intl.formatMessage(
        faqMessage,
        {
            ...pageContext,
            costExplanation,
            payPalFaq,
            acceptedLocations
        }
    );
};

export const getPrivacyPolicy = (intl) => {
    const privacyPolicyMessage = legalMessages.privacyPolicy;
    return intl.formatMessage(privacyPolicyMessage);
};


export default {
    getBalanceOrCustomerSupportUrl,
    getViewBalanceUrlOrPhone,
    getTermsAndConditions,
    getUyoTermsAndConditions,
    getFAQ,
    getPrivacyPolicy
};
